import { useState, useEffect } from "react"
import "./AddUser.css"
import { UserType } from "../DropdownOptions"
import { addUser, getProject } from "../../Service"
import { toast } from "react-toastify"

const AddUser = ({ isOpen, onClose }) => {
  const [username, setUsername] = useState("")
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")
  const [role, setRole] = useState("")
  const [projects, setProjects] = useState([])
  const [selectedProjectIds, setSelectedProjectIds] = useState([])
  const [allProjects, setAllProjects] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    if (!isOpen) return

    const fetchProjects = async () => {
      try {
        const response = await getProject("/projects")
        setProjects(Array.isArray(response) ? response : [])
      } catch (error) {
        console.error("Failed to fetch projects:", error)
        setProjects([])
      }
    }

    fetchProjects()
  }, [isOpen])

  const toggleProject = (projectId) => {
    setSelectedProjectIds((previous) =>
      previous.includes(projectId)
        ? previous.filter((id) => id !== projectId)
        : [...previous, projectId]
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username.trim() || !fullName.trim() || !email.trim() || !role) {
      toast.warning("Please fill in all the required fields.")
      return
    }

    if (!allProjects && selectedProjectIds.length === 0) {
      toast.warning("Assign at least one project, or tick 'Assign all projects'.")
      return
    }

    const userData = {
      username,
      full_name: fullName,
      email,
      role,
      all_projects_access: allProjects,
      project_ids: allProjects ? [] : selectedProjectIds,
    };

    setIsSaving(true)

    try {
      await addUser("/users", userData);

      setUsername("");
      setFullName("");
      setEmail("");
      setRole("");
      setSelectedProjectIds([]);
      setAllProjects(false);
      onClose();
    } catch (error) {
      console.error("Error creating user:", error);
    } finally {
      setIsSaving(false)
    }
  };

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* Header */}
        <div className="modal-header">
          <h2>Add User</h2>
          <div className="modal-actions">
            <button className="icon-button" onClick={onClose}>
              <h1 className="close-icon">X</h1>
            </button>
          </div>
        </div>


        <form onSubmit={handleSubmit} style={{padding:"20px"}}>
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input className="form-control" type="text" id="username" maxLength={50} style={{width:"100%"}} value={username} onChange={(e) => setUsername(e.target.value)} required placeholder="Enter a username" />
          </div>
          <div className="form-group">
            <label htmlFor="fullName">Full Name:</label>
            <input className="form-control" type="text" id="fullName" maxLength={100} style={{width:"100%"}} value={fullName} onChange={(e) => setFullName(e.target.value)} required placeholder="Enter full name"/>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              className="form-control"
              type="email"
              id="email"
              style={{ width: "100%" }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={(e) => {
                const value = e.target.value;
                if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                  toast.warning("Please enter a valid email address");
                  setEmail("");
                }
              }}
              required
              placeholder="Enter email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="role">Role:</label>
            <select className="form-control" value={role} onChange={(e) => setRole(e.target.value)} style={{width:"100%"}}>
                <option disabled value="">Select a Role</option>
                {UserType.map((user) => (
                    <option key={user.value} value={user.value}>
                    {user.type}
                    </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label>Project Access:</label>

            <label style={{ display: "flex", alignItems: "center", gap: "8px", margin: "6px 0", fontWeight: "bold" }}>
              <input
                type="checkbox"
                checked={allProjects}
                onChange={(e) => setAllProjects(e.target.checked)}
                style={{ width: "16px", height: "16px" }}
              />
              Assign all projects
            </label>
            <p style={{ fontSize: "11px", color: "gray", margin: "0 0 8px" }}>
              Gives access to every project, including ones created later.
            </p>

            {!allProjects && (
              <div
                style={{
                  maxHeight: "140px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  padding: "8px",
                }}
              >
                {projects.length === 0 ? (
                  <p style={{ fontSize: "12px", color: "gray", margin: 0 }}>No projects available.</p>
                ) : (
                  projects.map((project) => (
                    <label
                      key={project.project_id}
                      style={{ display: "flex", alignItems: "center", gap: "8px", margin: "4px 0" }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedProjectIds.includes(project.project_id)}
                        onChange={() => toggleProject(project.project_id)}
                        style={{ width: "16px", height: "16px" }}
                      />
                      {project.project_name}
                      <span style={{ fontSize: "11px", color: "gray" }}>({project.project_key})</span>
                    </label>
                  ))
                )}
              </div>
            )}
          </div>
        </form>

        {/* Footer */}
        <div className="modal-footer">
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                <button type="button" className="btn btn-outline" onClick={onClose}>
                Cancel
                </button>
                <button type="submit" className="btn btn-primary" onClick={handleSubmit} disabled={isSaving}>
                {isSaving ? "Saving..." : "Save"}
                </button>
            </div>
        </div>
      </div>
    </div>
  )
}

export default AddUser
